/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { personRefreshSummary } from '../../axios/personRefreshSummary'
import type {
	PersonRefreshSummaryError,
	PersonRefreshSummaryPathParams,
	PersonRefreshSummaryResponse,
} from '../../types/PersonRefreshSummary'

export const personRefreshSummaryMutationKey = () =>
	[{ url: '/organisations/:organisationId/persons/:person/refresh-summary' }] as const

export type PersonRefreshSummaryMutationKey = ReturnType<typeof personRefreshSummaryMutationKey>

export type PersonRefreshSummaryVariables = {
	organisationId: PersonRefreshSummaryPathParams['organisationId']
	person: PersonRefreshSummaryPathParams['person']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::refreshSummary */
export function usePersonRefreshSummary<TContext = unknown>(
	options?: UseMutationOptions<
		PersonRefreshSummaryResponse,
		AxiosError<PersonRefreshSummaryError>,
		PersonRefreshSummaryVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: personRefreshSummaryMutationKey(),
		mutationFn: ({ organisationId, person }: PersonRefreshSummaryVariables) =>
			personRefreshSummary(organisationId, person, config).then(res => res.data),
		...options,
	})
}
